import { render, staticRenderFns } from "./AbTextarea.vue?vue&type=template&id=6560f80b&scoped=true"
import script from "./AbTextarea.vue?vue&type=script&lang=js"
export * from "./AbTextarea.vue?vue&type=script&lang=js"
import style0 from "./AbTextarea.vue?vue&type=style&index=0&id=6560f80b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560f80b",
  null
  
)

export default component.exports